/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module indent
 */

import Indent from './indent';
import IndentEditing from './indentediting';
import IndentUI from './indentui';
import IndentBlock from './indentblock';

export default {
	Indent,
	IndentEditing,
	IndentUI,
	IndentBlock
};
